// extracted by mini-css-extract-plugin
export var priceItem = "PriceList-module--price-item--88e89";
export var priceItemInner = "PriceList-module--price-item-inner--8b648";
export var priceItemWrapper = "PriceList-module--price-item-wrapper--707d5";
export var prices = "PriceList-module--prices--4ed33";
export var pricesColumn = "PriceList-module--prices-column--7b8ee";
export var separatorGray = "PriceList-module--separator-gray--f72fc";
export var topDisplaimer = "PriceList-module--top-displaimer--d63c9";